module.exports = __webpack_public_path__ + "03_short_black.c971e0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_short_black.png
// module id = v7e9
// module chunks = 0